var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "content-container", attrs: { fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "text-center", staticStyle: { width: "100%" } },
        [
          _c(
            "v-btn",
            {
              attrs: { loading: _vm.isMoreLoading, color: "primary" },
              on: { click: _vm.loadMore },
            },
            [
              _vm._v(
                "\n            Show next " + _vm._s(_vm.showNext) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }